export function getLanguage() {
  return navigator.language.slice(0, 2)
}
